import { AccountingBalancePostingsService_balancePostingsServiceGetQuery } from '@festina/life-general-types/life/hooks/AccountingBalancePostingsService_balancePostingsServiceGetQuery'

export const useLazyFetchAccountBalancePostings =
  AccountingBalancePostingsService_balancePostingsServiceGetQuery.useLazyQuery
